<template>
  <mdb-container>
    <hr class="my-2">
    <div>
      <mdb-btn @click="switchFunction(0)" color="green"   class="show-button" v-bind:disabled="disabledStatuses[0]">input csv</mdb-btn>
      <mdb-btn @click="switchFunction(1)" color="primary" class="show-button" v-bind:disabled="disabledStatuses[1]">TABLE Format</mdb-btn>
      <mdb-btn @click="switchFunction(2)" color="primary" class="show-button" v-bind:disabled="disabledStatuses[2]">SQL Format</mdb-btn>

    </div>
    <hr class="my-2">

    <div v-if="disabledStatuses[0]">
      <mdb-btn @click="convertCsvData()"    color="orange" size="sm" class="show-button">Convert</mdb-btn>
      <mdb-btn @click="clearInputtedData()" color="green"  size="sm" class="show-button button-spacing-01">Clear</mdb-btn>
      <mdb-btn @click="setSampleCSVData()"  color="info"   size="sm" class="show-button button-spacing-01">Set Sample Data</mdb-btn>
      <textarea
        wrap="off"
        class="form-control" 
        id="quickReplyFormComment" 
        rows="12"
        placeholder="Input CSV Data..."
        v-model="targetCSV"></textarea>

      <div v-if="convertedData"><span class="inform-text">Look at [TABLE Format]/[SQL Format]</span></div>
      <div v-else v-bind:class="animationClass01">Convert Data is not created yet.</div>
    </div>

    <div v-if="disabledStatuses[1]">
      <div v-if="!convertedData">Input and Convert CSV Data</div>

      <mdb-datatable
        v-if="convertedData"
        :data="convertedData"
        striped
        bordered
        materialInputs
      />
    </div>

    <div v-if="disabledStatuses[2]">
      <div v-if="!convertedSql">Input and Convert CSV Data</div>
      <div v-else>
        <mdb-popover trigger="click" :options="{placement: 'top'}" class="mt-5">
          <span slot="body">copied to clipboard!</span>
          <mdb-btn slot="reference" color="default" @click="copyToClipboard()" size="sm" class="show-button">
            Copy To Clipboard
          </mdb-btn>
        </mdb-popover>

        <input type="checkbox" id="isUseForOracle" v-model="isUseForOracle" @click="editSqlData()">
        <label for="isUseForOracle">Use For Oracle</label>

        <div class="form-group px-2">
          <textarea 
            v-model="convertedSql" 
            class="form-control pl-3 pt-3" 
            id="sql-format-data" 
            rows="12" 
            wrap="off"
            readonly></textarea>
        </div>
      </div>
    </div>

  </mdb-container>
</template>

<script>
import { mdbDatatable, mdbPopover, mdbCollapse, mdbBtn, mdbContainer, mdbCol, mdbRow, mdbCard, mdbCardBody, mdbIcon } from 'mdbvue';
import { getSampleData } from '@/utils/sampleCSVData01'
import { convertCsvToJson } from '@/utils/csvParse'
import { convertCsvToSql  } from '@/utils/csvToSql'
import mockJsonData01 from '@/assets/mockdata/samplejson01.json';
import mockJsonData03 from '@/assets/mockdata/samplejson03.json';


export default {
  name: 'CollapsePage',
  components: {
    mdbDatatable,
    mdbPopover,
    mdbCollapse,
    mdbBtn,
    mdbContainer,
    mdbCol,
    mdbRow,
    mdbCard,
    mdbCardBody,
    mdbIcon
  },
  data() {
    return {
      mockJsonData01 : mockJsonData01,
      mockCsvData  : null,
      disabledStatuses : [true, false, false],
      targetCSV : null,
      convertedData : null,
      convertedSql  : null,
      isUseForOracle : false,
      animationClass01 : ""
    };
  },
  methods: {
    switchFunction(fno){
      this.disabledStatuses = this.disabledStatuses.map((el) => false);
      this.disabledStatuses[fno] = true;
    },
    setSampleCSVData(){
      this.targetCSV = getSampleData();
      //開発用
      // this.convertedData = mockJsonData03;
    },
    copyToClipboard(){
      const copyText = document.querySelector("#sql-format-data");
      copyText.select();
      document.execCommand('copy');
    },
    clearInputtedData(){
      this.targetCSV = "";
      this.convertedData = "";
      this.convertedSql = "";
    },
    convertCsvData(){
      this.convertedData = convertCsvToJson(this.targetCSV);
      this.convertedSql  = convertCsvToSql(this.targetCSV, this.isUseForOracle);

      if( this.convertedData == null || this.convertedData == ""){
        this.animationClass01 = "animated bounce infinite"
        setTimeout(()=> this.animationClass01 = "", 1000);
      }
    },
    editSqlData(){
      //何でここに「!」が必要かは、分かってないんだぜ。タイミングの問題？　何故か逆になってたからそうした。原因調査中。
      this.convertedSql  = convertCsvToSql(this.targetCSV, !this.isUseForOracle);
    }
  }
};
</script>

<style scoped>
.collapse-item {
  overflow: hidden;
  height: 0;
  padding: 0;
  transition: height .5s;
}

.button-spacing-01{
  margin-left: 10.0em
}

.inform-text{
  color: #FA2773;
}
</style>
